export default {
  namespaced: true,
  state: {
    user: {},
    role: '',
    people: [],
    details: [],
    drawerOpen: false,
    selectedProfileIndex: null,
    selectedProfile: {},
    formErrors: [],
    isLoaded: false,
    customerFileCompletion: 0,
  },
  mutations: {
    setCurrentUser: (state, user) => {
      state.user = user
    },
    setCurrentRole: (state, role) => {
      state.role = role
    },
    setCurrentPeople: (state, people) => {
      state.people = people
    },
    updatePerson: (state, data) => {
      const copyData = JSON.parse(JSON.stringify(data))
      if (copyData.id === state.user.id) {
        state.user = copyData
      } else {
        const index = state.details.findIndex((obj) => obj.id === copyData.id)
        state.details[index] = copyData
      }
    },
    updatePersonConsent: (state, data) => {
      state.user.user_consent = data.user_consent
    },
    updatePersonMetaDocs: (state, data) => {
      const copyData = JSON.parse(JSON.stringify(data))
      if (copyData.id === state.user.id) {
        state.user.meta = copyData.meta
        state.user.supporting_documents = copyData.supporting_documents
      } else {
        const index = state.details.findIndex((obj) => obj.id === copyData.id)
        state.details[index].meta = copyData.meta
        state.details[index].supporting_documents = copyData.supporting_documents
      }
    },
    updateSelectedPersonMetaDocs: (state, data) => {
      state.selectedProfile.meta = data.meta
      state.selectedProfile.supporting_documents = data.supporting_documents
    },
    updateSelectedPerson: (state, data) => {
      state.selectedProfile = data
    },
    setPeopleDetails: (state, details) => {
      state.details = details
    },
    closeDrawer(state) {
      state.drawerOpen = false
    },
    openDrawer(state) {
      state.drawerOpen = true
    },
    selectProfile(state, id) {
      state.selectedProfileIndex = id
      const profile =
        state.user.id === id
          ? state.user
          : state.details.find((person) => person.id === state.selectedProfileIndex)

      state.selectedProfile = profile
    },
    resetProfile(state) {
      const allPeopleDetails = [...state.details, state.user,]

      const copyProfile = Object.assign(
        {},
        allPeopleDetails.find((person) => person.id === state.selectedProfileIndex)
      )
      state.selectedProfile = copyProfile
    },
    setFormErrors(state, errors) {
      state.formErrors = errors
    },
    removeFieldErrors(state, fieldName) {
      const errors = Object.assign({}, state.formErrors)
      delete errors[fieldName]
      state.formErrors = errors
    },
    resetFormErrors(state) {
      state.formErrors = []
    },
    setCustomerFileCompletion: (state, completion) => {
      state.customerFileCompletion = completion
    },
  },
  getters: {
    currentUserRole: (state) => {
      return state.role
    },
    currentUserId: (state) => {
      const user = state.user

      return user ? user.id : null
    },
    currentUserName: (state) => {
      const user = state.user

      if (user && user.lastName) {
        return `${user.firstName} ${user.lastName}`
      }

      return ''
    },
    currentUser: (state) => {
      const user = state.user

      return user
    },
    loggedIn(state) {
      return !!state.user
    },
    currentPeople: (state) => {
      const people = state.people

      return people
    },
    peopleDetails: (state) => {
      const people = state.details

      return people
    },
    selectedProfileIndex: (state) => {
      return state.selectedProfileIndex
    },
    selectedProfile: (state) => {
      return state.selectedProfile
    },
    selectedProfileIsLoaded: (state) => {
      return Boolean(state.selectedProfile && state.selectedProfile.id)
    },
    drawerOpen: (state) => {
      return state.drawerOpen
    },
    isLoaded: (state) => {
      return state.isLoaded
    },
    formErrors: (state) => {
      return state.formErrors
    },
    customerFileCompletion: (state) => {
      return state.customerFileCompletion
    },
  },
}
